import React from 'react'
import ModelBoxSelection from '../Models/ModelBoxSelection'

function TryModels() {
  return (
    <div>
      <ModelBoxSelection />
    </div>
  )
}

export default TryModels